import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * Admin-configured individual USERS to email for issues of a given category,
 * alongside the role-based config (issue_notification_role_config).
 *
 * Include-only (Layer 1 — recipient routing): a row means "also notify this
 * user for issues in this category," on top of assignee / watchers / client
 * salesperson. It only ever ADDS recipients.
 *
 * HOW each resolved recipient is reached (in-app bell / email / push), and
 * whether they opt out entirely, is Layer 2 — the per-user
 * `user_notification_preference` applied at the dispatch choke point
 * (`NotificationDispatchService`). Layer 2 can drop or re-route a channel but
 * never adds a recipient Layer 1 didn't resolve; the two layers are composed,
 * never merged. See docs/claude/notifications/issue-routing-composition.md.
 *
 * One row per (category, user). `category` is a LinkableEntityType value or
 * 'general'; `fkUserId` references user._id (the tenant user).
 */
@Index('UK_issue_notification_user_config', ['category', 'fkUserId'], {
	unique: true,
})
@Index('idx_issue_notification_user_config_category', ['category'], {})
@Entity('issue_notification_user_config')
export class IssueNotificationUserConfigEntity extends BaseEntity {
	// A LinkableEntityType value (e.g. 'vehicle', 'client') or 'general'.
	@Column('varchar', { name: 'category', length: 50 })
	public category!: string;

	// FK to user._id — the user to also notify for this category.
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;
}
